import { Link } from "react-router-dom";
import Nav from "../Nav";
import Head from "../Head";

const Residencias = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Residencias" />
      <Nav titulo="Residencias" link="/" />
      <section
        id="menu"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="cardMenu">
          <img src="../img/mudar/mudar (4).jpg" alt="Residencias" />
          <Link to={"./mudar"} className="boton">
            Mudar
          </Link>
        </div>
        <div className="cardMenu">
          <img
            src="../img/talleres/espacio_analogico (1).jpg"
            alt="Residencias"
          />
          <Link to={"./espacio_analogico"} className="boton">
            Espacio analógico
          </Link>
        </div>
        <div className="cardMenu">
          <img src="../img/ir_al_rio/ir_al_rio (4).jpg" alt="Residencias" />
          <Link to={"./ir_al_rio"} className="boton">
            Ir al río
          </Link>
        </div>
      </section>
    </>
  );
};

export default Residencias;
